import { View } from "react-native";
import { Text, Card } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import CombinationSwitch from "./CombinationSwitch";
import { TextInputHelperText } from "../../../../components";
import NumberInput from "../../components/NumberInput";

type Props = {
  enabled: boolean;
  quantity: number;
  setEnabled: (enabled: boolean) => void;
  setQuantity: (quantity: number) => void;
};

export default function CombinationInventoryForm({
  enabled,
  quantity,
  setEnabled,
  setQuantity,
}: Props) {
  const tailwind = useTailwind();
  return (
    <Card style={tailwind("mx-3 mb-3 rounded-xl")}>
      <Card.Content>
        <CombinationSwitch enabled={enabled} setEnabled={setEnabled} />

        {enabled && (
          <View style={tailwind("mt-8")}>
            <Text variant="titleMedium">Inventario disponible</Text>
            <NumberInput value={quantity} onChangeValue={setQuantity} />
            <TextInputHelperText info="Ingresa el inventario disponible" />
          </View>
        )}
      </Card.Content>
    </Card>
  );
}
